import script from "./device-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./device-list.vue?vue&type=script&lang=ts&setup=true"

import "./device-list.vue?vue&type=style&index=0&id=15789dcd&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15789dcd"]])

export default __exports__